import Vuex from 'vuex';
import Vue from 'vue';
import cart from './modules/cart';
import auth from './modules/auth';
import constants from './modules/constants';
import megamenu from './modules/megamenu';

// Load Vuex
Vue.use(Vuex);

// Create store
export default new Vuex.Store({
	modules: {
		cart,
		auth,
		constants,
		megamenu,
	}
});
